export default __webpack_public_path__ + "static/media/ic-cc-5.8bff6f49.svg";